import type { RequestConfig } from '@customTypes/index';
import type { Role } from '@customTypes/types'; // Artist | Clubowner

import { api } from '@/shared/api/instance';

/** body sent to POST /api/loyalty/generate */
type GenerateLoyaltyTokenBody = {
  role: Role; // NEW
};

export type GenerateLoyaltyTokenParams =
  RequestConfig<GenerateLoyaltyTokenBody>;

type GenerateLoyaltyTokenResponse = {
  token: string;
  message: string;
};

export const generateLoyaltyToken = async ({
  params,
  config
}: GenerateLoyaltyTokenParams) =>
  api.post<GenerateLoyaltyTokenResponse>(
    '/api/loyalty/generate',
    params, // { role }
    config
  );
